import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyInfoStateService } from '../../../contact/services/company-info-state.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginStateService } from '../../services/login-state.service';

@Component({
  selector: 'app-reset-password-main',
  templateUrl: './reset-password-main.component.html',
  styleUrls: ['./reset-password-main.component.css']
})
export class ResetPasswordMainComponent implements OnInit {
  password: string;
  repeatPassword: string;
  error: string;
  token: string;

  @ViewChild(NgForm, {static: true}) form;

  constructor(
    private router: Router,
    private companyInfoStateService: CompanyInfoStateService,
    private activatedRoute: ActivatedRoute,
    private loginStateService: LoginStateService,
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit() {
  }

  get phone(): string {
    if (this.companyInfoStateService.companyInfo) {
      return this.companyInfoStateService.companyInfo.phone;
    }
    return '';
  }

  get isFormValid() {
    return this.form.valid;
  }

  onChangePassword(password: string, repeatPassword: string) {
    if (!this.isFormValid || this.password !== this.repeatPassword) {
      return;
    }
    if (this.token) {
      this.loginStateService.resetPasswordByToken(this.token, password, repeatPassword).subscribe(
        (message: string) => {
          if (message) {
            this.error = message;
          } else {
            this.router.navigateByUrl('login');
          }
        },
        (error: Error) => {
          this.error = error.message;
        },
      );
    }
  }
}
